<template>
  <div v-if="fullReportExportInProgress" class="px-1 d-flex align-center w-100 flex-wrap">
    <span class="text-body-3 text-light font-weight-bold text-decoration-underline mr-1">Filters applied:</span>
    <div class="text-body-3 text-light mr-2">
      <strong>Date:</strong>
      {{ selectedDateRangeLabel }}
    </div>
    <div
      v-for="filter in selectedFiltersLabels"
      :key="`selected-filter-${filter.label}`"
      class="text-body-3 text-light mr-2"
    >
      <strong>{{ filter.label }}:</strong>
      {{ filter.values }}
    </div>
  </div>
</template>

<script setup>
import { storeToRefs } from 'pinia';
import { useFilters } from '@/stores/filters/filters';
import { useDatePicker } from '@/stores/filters/datePicker';
import { computed } from 'vue';
import { format } from 'date-fns';
import { useInsightsExport } from '@/stores/insights/export';
import { READABLE_FORMAT } from '@/helpers/date';

const { selectedFiltersLabels } = storeToRefs(useFilters());
const { sortedRange } = storeToRefs(useDatePicker());
const { fullReportExportInProgress } = storeToRefs(useInsightsExport());

const selectedDateRangeLabel = computed(() => {
  if (Array.isArray(sortedRange.value) && sortedRange.value.length === 2) {
    let [start, end] = sortedRange.value;

    start = start instanceof Date ? start : new Date(start);
    end = end instanceof Date ? end : new Date(end);

    if (Number.isNaN(start.getTime()) || Number.isNaN(end.getTime())) return '';

    return `${format(start, READABLE_FORMAT)} - ${format(end, READABLE_FORMAT)}`;
  }

  return '';
});
</script>

<style scoped lang="less">
.text-light {
  color: @text-light;
}
</style>
